import Vue from 'vue';
import Modal from '../modal';

const emtpyFn = () => {};

function modalBox(options) {
  const $promise = new Promise((resolve) => {
    const {
      onConfirm,
      onCancel,
      onClose,
      ...otherOptions
    } = options;

    const $confirm = (action) => {
      if (action === 'confirm') {
        onConfirm && onConfirm();
      } else if (action === 'cancel') {
        onCancel && onCancel();
      } else {
        onClose && onClose();
      }
      resolve(action);
    };

    const ModalBox = Vue.extend({
      render(h) {
        return h(Modal, {
          props: {
            ...otherOptions,
            value: true,
          },
          on: {
            confirm: () => $confirm('confirm'),
            cancel: () => $confirm('cancel'),
            close: () => $confirm('close'),
          },
        });
      },
    });

    new ModalBox().$mount();
  });

  $promise.catch(emtpyFn);
  return $promise;
}

export default modalBox;
